import React from "react";
import { useTheme } from "@material-ui/core/styles";
import { Button, ButtonGroup } from "@mui/material";
import { dashboardColors, isDashboardDark } from "./dashboardTheme";

const PERIODS = [
  { id: "today", label: "Hoy" },
  { id: "7d", label: "7 días" },
  { id: "30d", label: "30 días" },
  { id: "month", label: "Mes" },
];

const PeriodFilter = ({ activePeriod, onChange }) => {
  const theme = useTheme();
  const isDark = isDashboardDark(theme);
  const colors = dashboardColors(isDark);

  return (
    <ButtonGroup
      variant="outlined"
      sx={{
        borderRadius: 2,
        "& .MuiButton-root": {
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.8125rem",
          px: 2,
          borderColor: isDark ? "rgba(148,163,184,0.35)" : "divider",
          color: colors.text,
        },
        "& .MuiButton-outlined": {
          color: colors.textMuted,
          "&:hover": {
            borderColor: isDark ? "rgba(148,163,184,0.5)" : undefined,
            backgroundColor: isDark ? "rgba(148,163,184,0.08)" : undefined,
          },
        },
        "& .MuiButton-contained": {
          boxShadow: "none",
          color: "#ffffff",
        },
      }}
    >
      {PERIODS.map((period) => (
        <Button
          key={period.id}
          variant={activePeriod === period.id ? "contained" : "outlined"}
          onClick={() => onChange(period.id)}
        >
          {period.label}
        </Button>
      ))}
    </ButtonGroup>
  );
};

export default PeriodFilter;
